export default __webpack_public_path__ + "static/media/inConstruction.3abaae4e.png";